<template v-if="renderComponent">
	<!-- <FormCard> -->
	<div class="flex items-center justify-between w-full gap-2 mb-4">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '')"
			>{{ tabName + " - " + subTabName }}
		</PageLabel>
		<div class="flex flex-row items-center gap-2">
			<Button id="btnback" v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)" @click.stop="changePage('prev')">Back </Button>
			<Button id="btnSaveGeneralInformation" @click.prevent="saveUtilities(true)" v-bind="lock.button.value" v-tooltip="lock.tooltip">Save</Button>
			<Button
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('next')"
			>
				Next
			</Button>
		</div>
	</div>
	<div class="flex mt-2 mb-2">
		<h2 v-show="props.tabName !== tabsDefinitions.packaging.value">
			{{ stepNumber + " - " + stepName }}
		</h2>
	</div>

	<!-- Energy Multipliers Section - Only for specific screens -->
	<div v-if="showEnergyMultipliers" class="flex flex-col gap-2 bg-white shadow sm:rounded-lg p-4 mb-6">
		<div class="flex items-center justify-between w-full gap-2 mb-4">
			<PageLabel>Energy Source Multipliers</PageLabel>
			<div class="flex gap-2" v-if="!energyMultipliersEditMode">
				<Button v-if="energyMultipliersType === 'assessment'" class="btn btn-primary" @click="enterEnergyMultipliersEditMode()" type="button">
					Edit
				</Button>
			</div>
			<div class="flex gap-2" v-else>
				<Button class="btn btn-secondary" @click="cancelEnergyMultipliersEdit()" type="button">Cancel</Button>
				<Button class="btn btn-primary" @click="saveEnergyMultipliers()" type="button">Save</Button>
			</div>
		</div>

		<!-- Type Selection -->
		<div class="flex justify-start mb-4">
			<div class="flex align-items-center gap-3">
				<label class="font-medium">Global Default</label>
				<ToggleSwitch
					:model-value="energyMultipliersType === 'assessment'"
					@update:model-value="(value) => onSwitchChange(value)"
					:disabled="!energyMultipliers || energyMultipliers.length === 0"
				/>
				<label class="font-medium">Assessment Specific</label>
			</div>
		</div>

		<!-- Energy Multipliers Table -->
		<div class="w-full">
			<DataTable :value="energyMultipliers" :loading="energyMultipliersLoading" stripedRows showGridlines responsiveLayout="scroll">
				<template #empty>
					<div class="flex items-center justify-center gap-3 p-4">
						<WarningIcon v-if="!energyMultipliersLoading" errorType="Warning" :tooltipText="[energyMultipliersEmptyMessage]" size="2x" />
						<span v-if="!energyMultipliersLoading" class="font-bold">{{ energyMultipliersEmptyMessage }}</span>
					</div>
				</template>

				<Column field="energy.energyName" header="Energy Type" :sortable="!energyMultipliersEditMode">
					<template #body="{ data }">
						<div>
							{{ data.energy?.energyName || "N/A" }}
						</div>
					</template>
				</Column>

				<Column field="value" :header="enerySourceUnit" :sortable="!energyMultipliersEditMode">
					<template #body="{ data }">
						<div v-if="!energyMultipliersEditMode">
							{{ formatValue(data.value) }}
						</div>
						<div v-else>
							<I2InputDecimal
								v-model="data.value"
								placeholder="Enter multiplier value"
								:inputClass="{ 'p-invalid': isEnergyMultiplierFieldInvalid(data, 'value') }"
								:allowNegative="false"
								class="w-full"
								@update:rawModelValue="(val) => energyMultiplierRawValues.set(data.energyId, val)"
							/>
						</div>
					</template>
				</Column>
			</DataTable>
		</div>
	</div>

	<I2FormRow class="mt-2 mb-2">
		<I2FormField label="Notes">
			<Textarea v-model="notes" placeholder="Please enter notes" rows="2" v-bind="lock.input.value" v-tooltip="lock.tooltip" />
		</I2FormField>
	</I2FormRow>
	<I2FormRow v-if="props.tabName === tabsDefinitions.biologics.value">
		<I2FormField label="Bulk Drug Substance (Dry Weight) Mass Output">
			{{ BDSMassOutput }}
		</I2FormField>
		<I2FormField label="Concentration of BDS in Production Bioreactor">
			{{ BDSConcentration }}
		</I2FormField></I2FormRow
	>
	<I2FormRow v-if="props.tabName === tabsDefinitions.biologics.value">
		<I2FormField label="Site Location">
			{{ siteLocation }}
		</I2FormField>
		<I2FormField label="Unit Operations" v-if="props.tabName === tabsDefinitions.syntheticAPI.value">
			{{ unitOperation }}
		</I2FormField></I2FormRow
	>
	<div class="flex mt-4 mb-2" v-if="false">
		<!-- Hidden per User Story 66642-->
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'UnitOperations'">{{
			props.tabName === tabsDefinitions.syntheticAPI.value
				? "Processing Operations"
				: props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value
					? "Processing and Cleaning"
					: ""
		}}</PageLabel>
	</div>

	<div v-if="false">
		<!-- Hidden per User Story 66642-->
		<DataTable
			:v-if="displayUnitOperation"
			:value="
				props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value
					? unitOperationStep
					: rawMaterialUnitOperation
			"
			responsiveLayout="scroll"
			:row-hover="true"
			dataKey="id"
			filterDisplay="menu"
			:loading="dataLoading"
			id="dtProcessingOperation"
			@value-change="nextPrevEnabled = checkIfAllMandatoryFieldsAreFilled()"
		>
			<template #empty> No processing operation found. </template>
			<template #loading>
				<div style="text-align: center; padding: 1rem">
					<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 mt-3 ml-2" spin />
					<p style="color: white !important">Loading processing operation data, please wait...</p>
				</div>
			</template>
			<Column
				field="unitOperation"
				:header="
					props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value ? 'Step Name' : 'Unit Operation'
				"
			>
				<template #body="{ data }">
					<div class="w-full" v-if="data.unitOperation && data.unitOperation.unitOperationName">{{ data.unitOperation.unitOperationName }}</div>
				</template>
			</Column>
			<Column
				field="duration"
				:header="
					'Duration' + (props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value ? ' (hours)' : '')
				"
			>
				<template #body="{ data, index }">
					<div v-if="props.tabName === tabsDefinitions.syntheticAPI.value">
						<InputText
							v-model="data.duration"
							maxlength="200"
							:class="{
								'p-invalid': saveAttempted && (!data.duration || data.duration == undefined || data.duration == null || data.duration == ''),
								'': data.duration != undefined && data.duration != null,
							}"
							v-on:keypress="numbersOnly"
							@change="updateProcessingOperationTable('durationChange', $event, data, index)"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
						<!--@blur="onDurationChange($event, data.id)"-->
					</div>
					<div v-if="props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value">
						{{ data.duration }}
					</div>
				</template>
			</Column>
			<Column
				field="roomSize"
				header="Room Size (m2)"
				v-if="props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value"
			>
				<template #body="{ data }">
					{{ data.roomSize }}
				</template>
			</Column>
			<Column field="unitId" header="Unit" v-if="props.tabName === tabsDefinitions.syntheticAPI.value">
				<template #body="{ data, index }">
					<!-- <div class="w-full">{{ data.unitId !== null ? unitList.filter((item) => item.id === data.unitId)[0].unitName : "" }}</div> -->
					<Select
						v-model="data.unitId"
						:options="unitList"
						optionLabel="unitName"
						optionValue="id"
						placeholder="Select Unit"
						class="w-full md:w-14rem"
						:class="{ 'p-invalid': saveAttempted && data.unitId == null, '': data.unitId !== null }"
						@change="updateProcessingOperationTable('unitChange', $event, data, index)"
						v-bind="lock.select.value"
						v-tooltip="lock.tooltip"
					>
					</Select>
				</template>
			</Column>
			<Column field="carbonFootprint" header="Carbon Footprint (kg CO2e)">
				<template #body="{ data }">
					<div class="w-full" v-if="data.id != selectedProcessingOperationId">{{ uiNumberFormatterAZ(data.carbonFootprint) }}</div>
					<div class="w-full" v-if="editProcessingOperationRow && data.id == selectedProcessingOperationId">
						{{ uiNumberFormatterAZ(calculatedCF) }}
						<!-- <InputText v-model="data.carbonFootprint" maxlength="200" /> -->
					</div>
				</template>
			</Column>
		</DataTable>
	</div>
	<div class="flex mt-6 mb-2">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'HVAC'">HVAC</PageLabel>
	</div>

	<I2FormRow class="mt-4 mb-2">
		<I2FormField label="HVAC Required">
			<div class="flex flex-wrap gap-3">
				<div class="flex align-items-center">
					<RadioButton
						v-model="hvacRequiredValue"
						inputId="ingredient1"
						name="hvacRequiredGroup"
						:value="false"
						@change="updateHvacData('radio', $event)"
						v-bind="lock.radio.value"
						v-tooltip="lock.tooltip"
					/>
					<label for="ingredient1" class="ml-2">No</label>
				</div>
				<div class="flex align-items-center">
					<RadioButton
						v-model="hvacRequiredValue"
						inputId="ingredient2"
						name="hvacRequiredGroup"
						:value="true"
						@change="updateHvacData('radio', $event)"
						v-bind="lock.radio.value"
						v-tooltip="lock.tooltip"
					/>
					<label for="ingredient2" class="ml-2">Yes</label>
				</div>
			</div>
		</I2FormField>
	</I2FormRow>
	<div v-if="hvacRequiredValue">
		<I2FormRow class="mt-6 mb-2">
			<I2FormField label="Facility Type">
				<Select
					v-model="selectedFacilityType"
					:options="facilityTypeList"
					optionLabel="isoClassFacilityTypeName"
					optionValue="id"
					placeholder="Select Facility Type"
					class="w-full md:w-14rem"
					@change="updateHvacData('facility', $event)"
					:class="{ 'p-invalid': saveAttempted && hvacRequiredValue && selectedFacilityType == null, '': selectedFacilityType !== null }"
					v-bind="lock.select.value"
					v-tooltip="lock.tooltip"
				>
				</Select>
			</I2FormField>
			<I2FormField label="Clean Room Class">
				<Select
					v-model="selectedCleanRoom"
					:options="cleanRoomList"
					optionLabel="hvacClassName"
					optionValue="id"
					placeholder="Select Clean Room"
					class="w-full md:w-14rem"
					@change="updateHvacData('cleanRoom', $event)"
					:disabled="selectedCleanRoomDisable || assessmentStore.isLocked"
					:class="{
						'p-invalid': saveAttempted && hvacRequiredValue && !isFacilityFine() && selectedCleanRoom == null,
						'': selectedCleanRoom !== null,
					}"
				>
				</Select>
			</I2FormField>
			<I2FormField label="Room Area (m2)">
				<InputText
					v-model="roomArea"
					maxlength="200"
					v-on:keypress="numbersOnly"
					@change="updateHvacData('room', $event)"
					:class="{
						'p-invalid': saveAttempted && hvacRequiredValue && (roomArea == null || roomArea == ''),
						'': roomArea !== null || roomArea !== '',
					}"
					v-bind="lock.input.value"
					v-tooltip="lock.tooltip"
				/>
			</I2FormField>
			<I2FormField label="Total Step Duration (hours)">
				<InputText
					v-model="duration"
					maxlength="200"
					v-on:keypress="numbersOnly"
					@change="updateHvacData('totalStep', $event)"
					:class="{
						'p-invalid': saveAttempted && hvacRequiredValue && (duration == null || duration == ''),
						'': duration !== null || duration !== '',
					}"
					v-bind="lock.input.value"
					v-tooltip="lock.tooltip"
				/>
			</I2FormField>
		</I2FormRow>
	</div>
	<div class="flex items-center justify-between w-full gap-2 mb-4 mt-6">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'Steam'">Steam Consumption</PageLabel>

		<div class="flex flex-row items-center gap-2">
			<Button class="btn" @click="setConsumptionDefaults('steam')" v-bind="lock.button.value" v-tooltip="lock.tooltip">Apply Default Values</Button>
		</div>
	</div>
	<div>
		<DataTable
			:v-if="displaySteamConsumptionList"
			:value="steamConsumptionList"
			responsiveLayout="scroll"
			:row-hover="true"
			dataKey="id"
			filterDisplay="menu"
			:loading="dataLoading"
			id="dtSteamConsumptionList"
			:class="{ 'invalid-table': saveAttempted && totalSteamConsumption != 100, '': totalSteamConsumption === 100 }"
			v-readonly-lock
		>
			<template #empty> No Steam Consumption found. </template>
			<template #loading>
				<div style="text-align: center; padding: 1rem">
					<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 mt-3 ml-2" spin />
					<p style="color: white !important">Loading Steam Consumption data, please wait...</p>
				</div>
			</template>
			<Column field="natualGas" header="Natual Gas (%)">
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.natualGas }} -->
						<InputText
							v-model="naturalGasValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'natualGas')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="coal" header="Coal (%)">
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.coal }} -->
						<InputText
							v-model="coalValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'coal')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="diesel" header="Diesel (%)">
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.diesel }} -->
						<InputText
							v-model="dieselValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'diesel')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="biomass" header="Biomass (%)">
				<template #body="{ data }">
					<div class="w-full">
						<!-- {{ data.biomass }} -->
						<InputText
							v-model="biomassValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalSteamConsumption"
							@change="checkIfEmpty('steamConsumption', 'biomass')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="biomass" header="Total (%)">
				<template #body="{ data }">
					<div class="w-full" :style="'color:' + checkIfTotalIs100(totalSteamConsumption) + ';font-weight:bold'">
						<b>{{ totalSteamConsumption }}</b>
					</div>
				</template>
			</Column>
		</DataTable>
	</div>
	<div class="flex items-center justify-between w-full gap-2 mb-4 mt-6">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'Electricity'"
			>Electricity Consumption</PageLabel
		>
		<div class="flex flex-row items-center gap-2">
			<Button class="btn" @click="setConsumptionDefaults('energy')" v-bind="lock.button.value" v-tooltip="lock.tooltip">Apply Default Values</Button>
		</div>
	</div>
	<I2FormRow class="flex mt-4 mb-2">
		<DataTable
			:v-if="displayEnergyConsumptionList"
			:value="energyConsumptionList"
			responsiveLayout="scroll"
			:row-hover="true"
			dataKey="id"
			filterDisplay="menu"
			:loading="dataLoading"
			id="dtEnergyConsumptionList"
			class="w-full"
			:class="{ 'invalid-table': saveAttempted && totalEnergyConsumption != 100, '': totalEnergyConsumption === 100 }"
			v-readonly-lock
		>
			<template #empty> No Electricity Consumption found. </template>
			<template #loading>
				<div style="text-align: center; padding: 1rem">
					<FontAwesomeIcon :icon="['fa', 'spinner']" size="3x" class="text-blue-500 mt-3 ml-2" spin />
					<p style="color: white !important">Loading Electricity Consumption data, please wait...</p>
				</div>
			</template>
			<Column field="gridAverageMix" header="Grid (Average Mix) (%)">
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="gridAverageMixValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'gridAverageMix')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="gridGreenTariff" header="Grid (Green Tariff) (%)">
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="gridGreenTariffValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'gridGreenTariff')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="solar" header="On-site Solar (%)">
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="solarValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'solar')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="wind" header="On-site Wind (%)">
				<template #body="{ data, index }">
					<div class="w-full">
						<InputText
							v-model="windValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							@change="checkIfEmpty('energyConsumption', 'wind')"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="onSiteHydro" header="On-site Hydro (%)">
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="onSiteHydroValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'onSiteHydro')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="onSiteBiomass" header="On-site Biomass (%)">
				<template #body="{ data }">
					<div class="w-full">
						<InputText
							v-model="onSiteBiomassValue"
							maxlength="200"
							v-on:keypress="numbersOnly"
							style="width: 100px"
							@blur="calculateTotalEnergyConsumption"
							@change="checkIfEmpty('energyConsumption', 'onSiteBiomass')"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template>
			</Column>
			<Column field="onSiteBiomass" header="Total (%)">
				<template #body="{ data }">
					<div class="w-full" :style="'color:' + checkIfTotalIs100(totalEnergyConsumption) + ';font-weight:bold'">
						{{ totalEnergyConsumption }}
					</div>
				</template>
			</Column>
		</DataTable>
	</I2FormRow>
	<div v-if="props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'WFI'">Water for Injection</PageLabel>

		<I2FormRow class="mt-6 mb-2">
			<I2FormField label="Source For On-Site Water for Injection">
				<Select
					v-model="selectedWfiSource"
					:options="wfiSources"
					optionLabel="wfiSourceName"
					optionValue="id"
					placeholder="Select WFI Source"
					class="w-full md:w-14rem"
					@change="viewWFIDetailsChangedWFI()"
					v-bind="lock.select.value"
					v-tooltip="lock.tooltip"
				>
				</Select>
			</I2FormField>
			<I2FormField label="View"
				><Button :class="'btn btn-primary ' + (wfiTableVisible ? 'inverted' : '')" id="btnback" @click="viewWFIDetails()">
					{{ (wfiTableVisible ? "Hide" : "View") + " Water For Injection Consumption" }}
				</Button></I2FormField
			>
		</I2FormRow>
		<I2FormRow>
			<DataTable v-if="wfiTableVisible" :value="wfiCalculated" :row-hover="true" dataKey="id" :loading="dataLoading" id="dtwfiList">
				<Column field="text" header="Consumption">
					<template #body="{ data }">
						<div class="w-full" v-if="data.isTitle">
							<strong>{{ data.text }}</strong>
						</div>
						<div class="w-full" v-else>{{ data.text }}</div>
					</template>
				</Column>

				<Column field="quantity" header="Quantity">
					<template #body="{ data }">
						<div class="w-full" v-if="data.isTitle"></div>
						<div class="w-full" v-else>{{ uiNumberFormatterAZ(data.quantity) }}</div>
					</template>
				</Column>

				<Column field="unit" header="Unit">
					<template #body="{ data }">
						<div class="w-full" v-if="data.isTitle"></div>
						<div class="w-full" v-else>{{ data.unit }}</div>
					</template>
				</Column>
			</DataTable>
		</I2FormRow>
	</div>

	<div v-if="props.tabName === tabsDefinitions.productProcess.value">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '') + 'ColdStorage'">Cold Storage</PageLabel>

		<I2FormRow class="mt-4 mb-2">
			<I2FormField label="Cold Storage Required">
				<div class="flex flex-wrap gap-3">
					<div class="flex align-items-center">
						<RadioButton
							v-model="coldStorageRequiredValue"
							inputId="coldStorageEnable1"
							name="coldStorageRequiredGroup"
							:value="false"
							@change="updateColdStorage"
							v-bind="lock.radio.value"
							v-tooltip="lock.tooltip"
						/>
						<label for="coldStorageEnable1" class="ml-2">No</label>
					</div>
					<div class="flex align-items-center">
						<RadioButton
							v-model="coldStorageRequiredValue"
							inputId="coldStorageEnable2"
							name="coldStorageRequiredGroup"
							:value="true"
							@change="updateColdStorage"
							v-bind="lock.radio.value"
							v-tooltip="lock.tooltip"
						/>
						<label for="coldStorageEnable2" class="ml-2">Yes</label>
					</div>
				</div>
			</I2FormField>
		</I2FormRow>
		<div v-if="coldStorageRequiredValue === true">
			<I2FormRow class="mt-6 mb-2">
				<I2FormField label="Temperature Requirements">
					<Select
						v-model="selectedTempRequirement"
						:options="tempRequirementsList"
						optionLabel="temperatureRequirement"
						optionValue="id"
						placeholder="Select Temperature Requirement"
						class="w-full md:w-14rem"
						@change="updateColdStorage"
						:class="{ 'p-invalid': saveAttempted && selectedTempRequirement == null, '': selectedTempRequirement !== null }"
						v-bind="lock.select.value"
						v-tooltip="lock.tooltip"
					>
					</Select>
				</I2FormField>
				<I2FormField label="Location">
					<Select
						v-model="selectedColdStorageLocation"
						:options="coldStorageLocationList"
						optionLabel="siteLocationName"
						optionValue="id"
						placeholder="Select Location"
						class="w-full md:w-14rem"
						@change="updateColdStorage"
						:class="{ 'p-invalid': saveAttempted && selectedColdStorageLocation == null, '': selectedColdStorageLocation !== null }"
						filter
						v-bind="lock.select.value"
						v-tooltip="lock.tooltip"
					>
					</Select>
				</I2FormField>
				<I2FormField label="Storage Time">
					<InputText
						v-model="coldStorageTime"
						maxlength="200"
						@change="updateColdStorage"
						v-on:keypress="numbersOnly"
						v-bind="lock.input.value"
						v-tooltip="lock.tooltip"
						:class="{
							'p-invalid': saveAttempted && (coldStorageTime == null || coldStorageTime == ''),
							'': coldStorageTime !== null || coldStorageTime != '',
						}"
					/>
				</I2FormField>
				<I2FormField label="Unit">
					<Select
						v-model="selectedColdStorageUnit"
						:options="selectedColdStorageUnitList"
						optionLabel="unitName"
						optionValue="id"
						placeholder="Select Storage Time Unit"
						class="w-full md:w-14rem"
						@change="updateColdStorage"
						:class="{ 'p-invalid': saveAttempted && selectedColdStorageUnit == null, '': selectedColdStorageUnit !== null }"
						v-bind="lock.select.value"
						v-tooltip="lock.tooltip"
					>
					</Select>
				</I2FormField>
			</I2FormRow>
		</div>
	</div>

	<!-- <div class="flex items-center justify-between w-full gap-2 mb-4 mt-12">
		<div></div>
		<div class="flex flex-row items-center gap-2">
			<Button
				class="btn btn-outline"
				id="btnback"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('prev')"
			>
				Back
			</Button>
			<button id="btnSaveGeneralInformation" class="btn" @click="saveUtilities(true)">Save</button>
			<button
				class="btn"
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('next')"
			>
				Next
			</button>
		</div>
	</div> -->

	<!-- <div class="flex gap-2 mt-5 mb-5">
		<div style="width: 80%">&nbsp;</div>
		<div class="flex flex-row items-center gap-2">

			<Button
				class="btn btn-outline"
				id="btnback"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('prev')"
			>
				Back
			</Button>
			<button id="btnSaveGeneralInformation" class="btn" @click="saveUtilities()">Save</button>
			<button
				class="btn"
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="!nextPrevEnabled"
				@click.stop="changePage('next')"
			>
				Next
			</button>
		</div>
	</div> -->
	<!-- </FormCard> -->
	<!-- <Toast position="top-right" /> -->
</template>

<script setup lang="ts">
import { ref, onMounted, watchEffect, watch, PropType, computed, nextTick } from "vue"
import { useConfigurationSettingHelper } from "@/composables/configurationSettingHelper"
import Textarea from "primevue/textarea"
import Select from "primevue/select"
import InputText from "primevue/inputtext"
import I2InputDecimal from "@/crispify/crispy-components/I2InputDecimal.vue"
import Checkbox from "primevue/checkbox"
import RadioButton from "primevue/radiobutton"
import Button from "primevue/button"
import {
	ApiClient,
	Assessment,
	Screen,
	GeneralInformation,
	Step,
	UtilitiesProcessingOperation,
	Utilities,
	RawMaterialUnitOperation,
	UnitOperationStep,
	SteamConsumptionDefault,
	EnergyConsumptionDefault,
	Unit,
	UtilitiesSteamConsumption,
	UtilitiesEnergyConsumption,
	ProcessingOperationCF,
	WIFIResults,
	HvacUtilitiesData,
	ColdStorageData,
	EnergyMultipliersClient,
	EnergyMultipliers,
	EnergySource,
	ProductFormatClient,
	GeneralInformationClient,
	ProjectClient,
} from "../../entities/NSwagGenerated"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
//import commonStep from "../components/commonStep.vue"
import { useToast } from "primevue/usetoast"
import { useConfirm } from "primevue/useconfirm"
import { EventBus } from "@/eventBus"
import DataTable, { DataTableRowEditCancelEvent } from "primevue/datatable"
import Column from "primevue/column"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faInfoCircle, faTrash, faPen, faFloppyDisk, faXmarkLarge, faWarning } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
library.add(faTrash, faPen, faInfoCircle, faFloppyDisk, faXmarkLarge, faWarning)
import WarningIcon from "./warningIcon.vue"

import { getCurrentInstance } from "vue"

import ToggleSwitch from "primevue/toggleswitch"
import { faXmark } from "@fortawesome/pro-solid-svg-icons"
import { uiNumberFormatterAZ } from "../composables/AZGlobalFunctions"
import { useTabsDefinitions } from "../composables/tabsDefinitions"
import { useHistoryHelper } from "../composables/historyHelper"
import { getEmptyGuid } from "@/composables/guidUtils"
import { util } from "zod/v4/core"
import { getNextFocusableElement } from "@primevue/core"
import { useErrorToaster } from "../composables/toaster"
import { useAssessmentStore } from "@/store/assessmentStore"
import { useAssessmentLock } from "@/composables/assessmentLock"

const assessmentStore = useAssessmentStore()
const lock = useAssessmentLock(assessmentStore)

const tabsDefinitions = useTabsDefinitions()
const { updateAssessmentUpdatedByDate } = useHistoryHelper()

const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
import { createHighPrecisionAxios, patchEntityForPrecision } from "@/composables/highPrecisionDecimal"
const energyMultipliersClient = new EnergyMultipliersClient(import.meta.env.VITE_API_URL?.toString(), createHighPrecisionAxios())
const confirmDialog = useConfirm()

const props = defineProps({
	assessmentId: {
		type: String,
		required: true,
		default: "",
	},
	tabName: {
		type: String,
		required: true,
		default: "",
	},
	subTabName: {
		type: String,
		required: true,
		default: "",
	},
	tabId: {
		type: String,
		required: true,
		default: "",
	},
	allTabsInformation: {
		type: Object,
		required: true,
		default: "",
	},
})

//Cold Storage GS
const coldStorageRequiredValue = ref(false)
const selectedTempRequirement = ref()
selectedTempRequirement.value = null
const tempRequirementsList = ref()
const selectedColdStorageLocation = ref()
selectedColdStorageLocation.value = null
const coldStorageLocationList = ref()
const coldStorageTime = ref()
coldStorageTime.value = ""
const selectedColdStorageUnit = ref()
selectedColdStorageUnit.value = null
const selectedColdStorageUnitList = ref()

let step = new Step()
const notes = ref()
const stepName = ref("")
const stepNumber = ref("")
let utilities = new Utilities()
let dataLoading = ref(false)
const hvacRequiredValue = ref(false)
const selectedFacilityType = ref()
const selectedCleanRoom = ref()
const roomArea = ref()
const duration = ref()
const selectedUnitId = ref()
const calculatedCF = ref()
const stepId = ref()
const actualGeneralInformation = ref()
let toast = useToast()
const selectedProcessingOperationId = ref()
const utilitiesSteamConsumptionObj: UtilitiesSteamConsumption = new UtilitiesSteamConsumption()
const utilitiesEnergyConsumptionObj: UtilitiesEnergyConsumption = new UtilitiesEnergyConsumption()
const naturalGasValue = ref(0)
const coalValue = ref(0)
const dieselValue = ref(0)
const biomassValue = ref(0)
const gridAverageMixValue = ref(0)
const gridGreenTariffValue = ref(0)
const solarValue = ref(0)
const windValue = ref(0)
const onSiteHydroValue = ref(0)
const onSiteBiomassValue = ref(0)
const totalSteamConsumption = ref(0)
const totalEnergyConsumption = ref(0)

const renderComponent = ref(true)
const displayUnitOperation = ref(false)
const displaySteamConsumptionList = ref(false)
const hasProductProcessTab = ref(false)
const displayEnergyConsumptionList = ref(false)
const editProcessingOperationRow = ref(false)
const saveAttempted = ref(false)
const saveUtilitiesData = ref(false)

// let processingOperationList = ref([] as UtilitiesProcessingOperation[])
const rawMaterialUnitOperation = ref([] as RawMaterialUnitOperation[])
const unitOperationStep = ref([] as UnitOperationStep[])
const facilityTypeList = ref([])
const cleanRoomList = ref([])
const steamConsumptionDefaultList = ref([] as SteamConsumptionDefault[])
const energyConsumptionDefaultList = ref([] as EnergyConsumptionDefault[])
const steamConsumptionList = ref([] as UtilitiesSteamConsumption[])
const energyConsumptionList = ref([] as UtilitiesEnergyConsumption[])
const unitList = ref([] as Unit[])

const thisStepStatus = ref(false)

//data from RawMaterials
const BDSMassOutput = ref()
const BDSConcentration = ref()
const siteLocation = ref()
const unitOperation = ref()

//WFI
const wfiSources = ref()
const selectedWfiSource = ref()
const wfiTableVisible = ref()
const wfiCalculated = ref([] as WIFIResults[])

const nextPrevEnabled = ref(false)

//autosave
const actualUilitiesId = ref()

//editing
const editMode = ref()
editMode.value = "cell"

const steamConsumptionErrorFlagged = ref(false)
const energyConsumptionErrorFlagged = ref(false)

// Energy Multipliers variables
const energyMultipliers = ref([] as EnergyMultipliers[])
const originalEnergyMultipliers = ref([] as EnergyMultipliers[])
const energySources = ref([] as EnergySource[])
const energyMultipliersEditMode = ref(false)
const energyMultipliersType = ref("global") // "global" or "assessment"
const energyMultipliersSaveAttempted = ref(false)
const energyMultipliersLoading = ref(false)
const energyMultiplierRawValues = new Map<string, string | null>()
const showEnergyMultipliers = ref(false)
const multiStepUtilitiesEnabled = ref<boolean>(false)

class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}
onMounted(() => {
	//getUtilitiesProcessingOperationByStepId()
	getAllFacilityType()
	//getAllCleanRoom()
	getAllUnit()
	getWFISource()
	getAllColdStorageDropdowns()

	// Check if Product Process tab exists for proper messaging
	checkSubprojectHasProductProcess()

	// Initialize energy multipliers - only check if screen is allowed, don't load data yet in onMounted
	showEnergyMultipliers.value = checkIfAllowedScreen()

	// Watch for changes in actualGeneralInformation to load energy multipliers when data is ready
	watch(actualGeneralInformation, (newValue, oldValue) => {
		if (newValue && newValue !== oldValue) {
			initializeEnergyMultipliers()
		}
	})

	EventBus.on("selectedStep_" + props.tabId, (data: any) => {
		stepId.value = data.id
		stepName.value = data.stepName
		stepNumber.value = data.stepNumber
		actualGeneralInformation.value = data.generalInformationId

		// Reload utilities data for the new step/generalInformation
		if (stepId.value) {
			getUtilitiesByStepId(stepId.value)
			viewWFIDetailsChangedWFI()
			initializeEnergyMultipliers()
		}
	})
	EventBus.on("UtilitiesUpdate" + props.tabId, () => {
		saveAttempted.value = false
		setPrimaryInformation().then(() => {
			if (stepId.value) {
				getUtilitiesByStepId(stepId.value)
				viewWFIDetailsChangedWFI()
				// Refresh Energy Source Multipliers every time utilities tab is viewed
				initializeEnergyMultipliers()
			}
		})
	})
	EventBus.on("nextPrevEnabled_" + props.tabId, () => {
		nextPrevEnabled.value = true
	})

	// Enable Next/Prev buttons immediately on mount
	EventBus.emit("nextPrevEnabled_" + props.tabId)
})

const enerySourceUnit = computed(() => {
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			return "kWh per kg API"
		case tabsDefinitions.biologics.value:
			return "kWh per kg wet BDS"
		case tabsDefinitions.productProcess.value:
			return "kWh/unit"
		case tabsDefinitions.packaging.value:
			return "kWh/unit"
		default:
			return "kWh/unit"
	}
})

function checkIfSteamElectricityAre100Perc(showToast: boolean = true) {
	// Skip validation if data is still loading or not yet initialized
	if (!displaySteamConsumptionList.value && !displayEnergyConsumptionList.value) {
		return true
	}

	var errors: boolean = false
	var errortext = []
	if (displaySteamConsumptionList.value && totalSteamConsumption.value !== 100) {
		errors = true
		errortext.push("Steam Consumption")
	}
	if (displayEnergyConsumptionList.value && totalEnergyConsumption.value !== 100) {
		errors = true
		errortext.push("Energy Consumption")
	}
	if (errors) {
		if (showToast) {
			var errorsText =
				"Please check " + (errortext.length > 1)
					? errortext.join(" & ")
					: errortext[0] + (errortext.length > 1)
						? " both "
						: "" + "need" + (errortext.length > 1)
							? "s"
							: "" + " to reach 100% as total"
			toast.add({
				severity: "error",
				summary: "Error",
				detail: "Please check " + errorsText + " to reach 100% as total",
			})
		}
		return false
	} else {
		return true
	}
}
const formatValue = (value: number | null | undefined): string => {
	if (value === null || value === undefined) return "0"

	// Format with comma for thousands and dot for decimals
	return value.toLocaleString("en-US", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 8,
	})
}

// Function to check if subproject has Product Process screen via API
async function checkSubprojectHasProductProcess(): Promise<void> {
	if (!props.assessmentId) return

	try {
		const result = await apiClient.checkIfSubprojectHasProductProcessScreen(props.assessmentId)
		hasProductProcessTab.value = result
	} catch (error) {
		console.error("Error checking if subproject has Product Process screen:", error)
		hasProductProcessTab.value = false
	}
}

// Computed property for the energy multipliers empty message
const energyMultipliersEmptyMessage = computed(() => {
	if (props.tabName === tabsDefinitions.syntheticAPI.value || props.tabName === tabsDefinitions.productProcess.value) {
		// Synthetic API or Product Process tab
		return "Please select a Product Format in the General Information tab to load energy multipliers."
	} else if (props.tabName === tabsDefinitions.packaging.value) {
		// Device & Packaging tab
		if (hasProductProcessTab.value) {
			return "Please select a Product Format in the Product Process General Information tab to load energy multipliers."
		} else {
			return "Please select a Product Format in the General Information tab to load energy multipliers."
		}
	}
	return "No energy multipliers found."
})

function updateColdStorage() {
	var coldData = new ColdStorageData()
	coldData.coldStorageRequired = coldStorageRequiredValue.value
	coldData.coldStorageUnit = selectedColdStorageUnit.value
	coldData.coldStorageLocationId = selectedColdStorageLocation.value
	coldData.coldSorageTime = coldStorageTime.value ? coldStorageTime.value : 0
	coldData.coldStorageId = selectedTempRequirement.value
	apiClient.updateColdStorage(actualUilitiesId.value, coldData).then((res) => {})
}

function updateHvacData(type: string, ev: any) {
	var hvacData = new HvacUtilitiesData()
	hvacData.utilitiesId = actualUilitiesId.value
	hvacData.hvacRequired = hvacRequiredValue.value
	if (hvacRequiredValue.value) {
		hvacData.facility = selectedFacilityType.value
		hvacData.cleanRoomClass = selectedCleanRoom.value
		roomArea.value = roomArea.value === "" || roomArea.value === null ? 0 : roomArea.value
		duration.value = duration.value === "" || duration.value === null ? 0 : duration.value
		hvacData.roomArea = roomArea.value
		hvacData.totalStep = duration.value
	}

	apiClient.updateHvacData(hvacData).then((res) => {
		switch (type) {
			case "radio":
			case "cleanRoom":
				break
			case "facility":
				facilityTypeChange(selectedFacilityType.value)
				selectedCleanRoom.value = null
				roomArea.value = null
				duration.value = null
				break
			case "room":
			case "totalStep":
				getRawMaterialUnitOperationByStepId(stepId.value)
				break
		}
	})
}

function updateProcessingOperationTable(type: string, ev: any, data: any, index: number) {
	switch (type) {
		case "durationChange":
			onDurationChange(ev, data.id)
			break
		case "unitChange":
			onUnitChange(ev, data.id)
			break
	}
}

function onCellEditComplete(ev: any) {
	const index = rawMaterialUnitOperation.value.findIndex((item) => item.id === ev.newData.id)
	if (index !== -1) {
		Object.assign(rawMaterialUnitOperation.value[index], ev.newData)
		switch (ev.field) {
			case "duration":
				rawMaterialUnitOperation.value[index].duration = ev.newData.duration
				break
			case "unitId":
				// rawMaterialUnitOperation.value[index].unit.unitName = unitList.value.filter(
				// 	(item: any) => item.id === rawMaterialUnitOperation.value[index].unitId
				// )[0].unitName

				//ev.newData.duration
				break
		}

		let processingOperationCF: ProcessingOperationCF = new ProcessingOperationCF()
		processingOperationCF.stepId = stepId.value
		processingOperationCF.utilitiesId = utilities.id
		processingOperationCF.rawMaterialUnitOperation = rawMaterialUnitOperation.value[index]
		processingOperationCF.steamConsumptionList = steamConsumptionList.value[0]
		processingOperationCF.energyConsumptionList = energyConsumptionList.value[0]
		apiClient.calculateProcessingOperationCF(processingOperationCF).then((result) => {
			if (result != null) {
				rawMaterialUnitOperation.value[index].carbonFootprint = parseFloat(result)
				calculatedCF.value = result
			}
		})
	}
}

function onDurationChange(event: any, id: string) {
	const index = rawMaterialUnitOperation.value.findIndex((item) => item.id === id)

	if (index !== -1) {
		//Object.assign(rawMaterialUnitOperation.value[index], id)
		rawMaterialUnitOperation.value[index].duration = event.target.value

		let processingOperationCF: ProcessingOperationCF = new ProcessingOperationCF()
		processingOperationCF.stepId = stepId.value
		if (utilities.id != null) {
			processingOperationCF.utilitiesId = utilities.id
		} else {
			processingOperationCF.utilitiesId = self.crypto.randomUUID()
		}
		processingOperationCF.rawMaterialUnitOperation = rawMaterialUnitOperation.value[index]

		processingOperationCF.steamConsumptionList = steamConsumptionList.value[0]
		processingOperationCF.energyConsumptionList = energyConsumptionList.value[0]

		if (processingOperationCF.rawMaterialUnitOperation.duration != null && processingOperationCF.rawMaterialUnitOperation.unitId != null) {
			apiClient.calculateProcessingOperationCF(processingOperationCF).then((result) => {
				if (result != null) {
					rawMaterialUnitOperation.value[index].carbonFootprint = parseFloat(result)
					calculatedCF.value = result
					apiClient.updateRawMaterialProcessingOperationTable(rawMaterialUnitOperation.value[index]).then((res) => {})
				}
			})
		}
	}
}

function onUnitChange(event: any, id: string) {
	const index = rawMaterialUnitOperation.value.findIndex((item) => item.id === id)

	if (index !== -1) {
		let processingOperationCF: ProcessingOperationCF = new ProcessingOperationCF()
		processingOperationCF.stepId = stepId.value
		if (utilities.id != null) {
			processingOperationCF.utilitiesId = utilities.id
		} else {
			processingOperationCF.utilitiesId = self.crypto.randomUUID()
		}
		processingOperationCF.rawMaterialUnitOperation = rawMaterialUnitOperation.value[index]
		processingOperationCF.steamConsumptionList = steamConsumptionList.value[0]
		processingOperationCF.energyConsumptionList = energyConsumptionList.value[0]

		if (processingOperationCF.rawMaterialUnitOperation.duration != null && processingOperationCF.rawMaterialUnitOperation.unitId != null) {
			apiClient.calculateProcessingOperationCF(processingOperationCF).then((result) => {
				if (result != null) {
					rawMaterialUnitOperation.value[index].carbonFootprint = parseFloat(result)
					calculatedCF.value = result
					apiClient.updateRawMaterialProcessingOperationTable(rawMaterialUnitOperation.value[index]).then((res) => {})
				}
			})
		}
	}
}

function getAllColdStorageDropdowns() {
	apiClient.getcoldStorageDropdowns().then((res) => {
		tempRequirementsList.value = res.tempRequirements
		coldStorageLocationList.value = res.siteLocations
		selectedColdStorageUnitList.value = res.unitsDistance
	})
}

function changePage(action: string) {
	if (action === "next") {
		if (!assessmentStore.isLocked) {
			if (!checkIfAllMandatoryFieldsAreFilled(true)) return
			saveUtilities(true)
		}
	}
	EventBus.emit("nextPreviousTab_" + props.tabId, {
		action: action,
		actualTab: props.tabId,
	})
}

function getWFISource() {
	apiClient.getWFISources().then((res) => {
		wfiSources.value = res
	})
}

function viewWFIDetails() {
	wfiTableVisible.value = !wfiTableVisible.value
	if (wfiTableVisible.value)
		apiClient.getWFISourceResults(stepId.value, selectedWfiSource.value).then((res) => {
			wfiCalculated.value = res
		})
}

function viewWFIDetailsChangedWFI() {
	if (wfiTableVisible.value)
		apiClient.getWFISourceResults(stepId.value, selectedWfiSource.value).then((res) => {
			wfiCalculated.value = res
		})
}

function setPrimaryInformation(): Promise<string> {
	return new Promise((resolve, reject) => {
		// var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
		// var toGetStatus = tabStatus.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
		// //selectedStepName.value = toGetStatus.actualSubTabName

		stepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
		actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
			(item: any) => item.actualMainTabId === props.tabId
		).generalInformationId
		resolve("Done")
	})
}
const forceRerender = async () => {
	// Remove MyComponent from the DOM
	renderComponent.value = false

	// Wait for the change to get flushed to the DOM
	await nextTick()

	// Add the component back in
	renderComponent.value = true
}

function checkSingleField(field: any) {
	return field !== null && field !== "" && field !== undefined
}

function checkListField(field: any) {
	return field.length > 0
}

function checkProcessinOperations() {
	var procStatus = true
	switch (props.tabName) {
		case tabsDefinitions.productProcess.value:
		case tabsDefinitions.biologics.value:
			unitOperationStep.value.forEach((item: any) => {
				procStatus = checkSingleField(item.duration) && checkSingleField(item.unitId)
			})
			break
		default:
			rawMaterialUnitOperation.value.forEach((item: any) => {
				procStatus = checkSingleField(item.duration) && checkSingleField(item.unitId)
			})
			break
	}
	return procStatus
}

function isFacilityFine() {
	var actualFT = facilityTypeList.value.find((item) => item.id === selectedFacilityType.value)
	var isConventional = actualFT?.isoClassFacilityTypeName === "Conventional HVAC (No Clean Room)"
	return isConventional
}

function checkMandatoryFields() {
	var actualFT = facilityTypeList.value.find((item) => item.id === selectedFacilityType.value)
	if (actualFT !== undefined) var isConventional = actualFT?.isoClassFacilityTypeName === "Conventional HVAC (No Clean Room)"
	//var isConventional = actualFT?.isoClassFacilityTypeName === "Conventional HVAC (No Clean Room)"
	//item.isoClassFacilityTypeName === "Conventional HVAC (No Clean Room)"
	switch (props.tabName) {
		case tabsDefinitions.biologics.value:
			var hvacVer = true
			if (hvacRequiredValue.value) {
				var hvacVer =
					checkSingleField(selectedFacilityType.value) &&
					(isConventional ? true : checkSingleField(selectedCleanRoom.value)) &&
					checkSingleField(roomArea.value) &&
					checkSingleField(duration.value)
			}
			return hvacVer
			break
		case tabsDefinitions.syntheticAPI.value:
			var hvacVer = true
			if (hvacRequiredValue.value) {
				var hvacVer =
					checkSingleField(selectedFacilityType.value) &&
					(isConventional ? true : checkSingleField(selectedCleanRoom.value)) &&
					checkSingleField(roomArea.value) &&
					checkSingleField(duration.value)
			}
			return hvacVer
		// return hvacVer && checkProcessinOperations()
		case tabsDefinitions.productProcess.value:
			var hvacVer = true
			if (hvacRequiredValue.value) {
				var hvacVer =
					checkSingleField(selectedFacilityType.value) &&
					(isConventional ? true : checkSingleField(selectedCleanRoom.value)) &&
					checkSingleField(roomArea.value) &&
					checkSingleField(duration.value)
			}

			var coldStorageVer = true
			if (coldStorageRequiredValue.value) {
				var coldStorageVer =
					checkSingleField(selectedTempRequirement.value) &&
					checkSingleField(selectedColdStorageLocation.value) &&
					checkSingleField(coldStorageTime.value) &&
					checkSingleField(selectedColdStorageUnit.value)
			}
			return hvacVer && coldStorageVer
			break
	}
	return true
}

function checkIfAllMandatoryFieldsAreFilled(showToast: boolean = false): boolean {
	return checkIfSteamElectricityAre100Perc(showToast) && checkMandatoryFields()
}

async function saveUtilities(showToast: boolean) {
	if (showToast) saveAttempted.value = true
	await nextTick()
	if (!checkIfSteamElectricityAre100Perc()) return
	if (!checkMandatoryFields()) {
		toast.add({
			severity: "error",
			summary: "Highlighted fields are required to save",
			detail: ``,

			group: props.tabId,
		})

		return
	}
	//return
	if (!testUtilitiesConsumption()) return
	if (utilities.id == null) {
		utilities.id = self.crypto.randomUUID()
		utilities.stepId = stepId.value
	}
	utilities.notes = notes.value
	if (hvacRequiredValue.value) {
		utilities.hvacRequired = true
		utilities.facilityTypeId = selectedFacilityType.value
		utilities.cleanRoomId = selectedCleanRoom.value
		utilities.roomArea = roomArea.value
		utilities.totalStepDuration = duration.value
	} else {
		utilities.hvacRequired = false
		utilities.facilityTypeId = null
		utilities.cleanRoomId = null
		utilities.roomArea = 0
		utilities.totalStepDuration = 0
	}
	utilities.wfiId = selectedWfiSource.value

	utilities.isColdStorage = coldStorageRequiredValue.value
	utilities.unitId = selectedColdStorageUnit.value
	utilities.locationId = selectedColdStorageLocation.value
	utilities.storageTime = coldStorageTime.value
	utilities.coldStorageId = selectedTempRequirement.value

	apiClient.postUtilities(utilities).then(
		(res) => {
			actualUilitiesId.value = res.id
			nextTick().then(() => {
				//save utilities steam consumption
				saveUtilitiesSteamConsumption()
				//save utilities energy consumption
				saveUtilitiesEnergyConsumption()

				saveAllProcessingOperation(rawMaterialUnitOperation.value)
				if (showToast) toast.add({ severity: "success", summary: "Saved!", detail: "", life: 3500, group: props.tabId })
				updateAssessmentUpdatedByDate(props.assessmentId)
			})
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
		}
	)
}

function saveUtilitiesProcessingOperation(row: any) {
	if (!testFields(row)) return
	editProcessingOperationRow.value = false
	apiClient.updateRawMaterialUnitOperation(row).then(
		(res) => {
			displayUnitOperation.value = false
			selectedProcessingOperationId.value = ""
			getRawMaterialUnitOperationByStepId(stepId.value)
		},
		(err) => {}
	)
}

function saveUtilitiesSteamConsumption() {
	utilitiesSteamConsumptionObj.naturalGas = naturalGasValue.value
	utilitiesSteamConsumptionObj.coal = coalValue.value
	utilitiesSteamConsumptionObj.diesel = dieselValue.value
	utilitiesSteamConsumptionObj.biomass = biomassValue.value
	// Always update utilitiesId and stepId to ensure correct association
	utilitiesSteamConsumptionObj.utilitiesId = utilities.id
	utilitiesSteamConsumptionObj.stepId = stepId.value
	if (!testUtilitiesSteamConsumption(utilitiesSteamConsumptionObj)) return

	apiClient.updateSteamConsumption(utilitiesSteamConsumptionObj).then((res) => {
		// Update the id from the response in case it was a new record
		if (res && res.id) {
			utilitiesSteamConsumptionObj.id = res.id
		}
	})
}

function saveUtilitiesEnergyConsumption() {
	utilitiesEnergyConsumptionObj.gridAverageMix = gridAverageMixValue.value
	utilitiesEnergyConsumptionObj.gridGreenTariff = gridGreenTariffValue.value
	utilitiesEnergyConsumptionObj.solar = solarValue.value
	utilitiesEnergyConsumptionObj.wind = windValue.value
	utilitiesEnergyConsumptionObj.onSiteHydro = onSiteHydroValue.value
	utilitiesEnergyConsumptionObj.onSiteBiomass = onSiteBiomassValue.value

	// Always update utilitiesId and stepId to ensure correct association
	utilitiesEnergyConsumptionObj.utilitiesId = utilities.id
	utilitiesEnergyConsumptionObj.stepId = stepId.value

	if (!testUtilitiesEnergyConsumption(utilitiesEnergyConsumptionObj)) return

	apiClient.updateEnergyConsumption(utilitiesEnergyConsumptionObj).then((res) => {
		// Update the id from the response in case it was a new record
		if (res && res.id) {
			utilitiesEnergyConsumptionObj.id = res.id
		}
	})
}

// Reset consumption data when switching between different generalInformation
function resetConsumptionData() {
	// Reset Steam Consumption values
	naturalGasValue.value = 0
	coalValue.value = 0
	dieselValue.value = 0
	biomassValue.value = 0
	totalSteamConsumption.value = 0

	// Reset Energy Consumption values
	gridAverageMixValue.value = 0
	gridGreenTariffValue.value = 0
	solarValue.value = 0
	windValue.value = 0
	onSiteHydroValue.value = 0
	onSiteBiomassValue.value = 0
	totalEnergyConsumption.value = 0

	// Reset Steam Consumption object
	utilitiesSteamConsumptionObj.id = ""
	utilitiesSteamConsumptionObj.stepId = ""
	utilitiesSteamConsumptionObj.utilitiesId = ""
	utilitiesSteamConsumptionObj.naturalGas = 0
	utilitiesSteamConsumptionObj.coal = 0
	utilitiesSteamConsumptionObj.diesel = 0
	utilitiesSteamConsumptionObj.biomass = 0

	// Reset Energy Consumption object
	utilitiesEnergyConsumptionObj.id = ""
	utilitiesEnergyConsumptionObj.stepId = ""
	utilitiesEnergyConsumptionObj.utilitiesId = ""
	utilitiesEnergyConsumptionObj.gridAverageMix = 0
	utilitiesEnergyConsumptionObj.gridGreenTariff = 0
	utilitiesEnergyConsumptionObj.solar = 0
	utilitiesEnergyConsumptionObj.wind = 0
	utilitiesEnergyConsumptionObj.onSiteHydro = 0
	utilitiesEnergyConsumptionObj.onSiteBiomass = 0

	// Reset lists
	steamConsumptionList.value = []
	energyConsumptionList.value = []

	// Hide display until data is loaded
	displaySteamConsumptionList.value = false
	displayEnergyConsumptionList.value = false
}

function getUtilitiesByStepId(stepId: string) {
	// Reset consumption data before loading new data for a different generalInformation
	resetConsumptionData()

	// For Packaging and Distribution tabs, use generalInformationId to get the correct utilities
	const isPackagingOrDistribution = props.tabName === tabsDefinitions.packaging.value || props.tabName === tabsDefinitions.distribution.value

	const utilitiesPromise =
		isPackagingOrDistribution && actualGeneralInformation.value
			? apiClient.getUtilitiesByStepIdAndGeneralInformationId(stepId, actualGeneralInformation.value)
			: apiClient.getUtilitiesByStepId(stepId)

	utilitiesPromise.then((result) => {
		if (result != null) {
			utilities = result
			notes.value = utilities.notes
			selectedWfiSource.value = utilities.wfiId
			if (utilities.hvacRequired !== undefined) {
				hvacRequiredValue.value = utilities.hvacRequired
			} else {
				hvacRequiredValue.value = false
			}

			coldStorageRequiredValue.value = utilities.isColdStorage !== undefined ? utilities.isColdStorage : false
			selectedColdStorageUnit.value = utilities.unitId
			selectedColdStorageLocation.value = utilities.locationId
			coldStorageTime.value = utilities.storageTime
			selectedTempRequirement.value = utilities.coldStorageId

			selectedFacilityType.value = utilities.facilityTypeId
			if (selectedFacilityType.value != null) {
				facilityTypeChange(selectedFacilityType.value)
			}
			selectedCleanRoom.value = utilities.cleanRoomId
			roomArea.value = utilities.roomArea
			duration.value = utilities.totalStepDuration
			thisStepStatus.value = true
			actualUilitiesId.value = utilities.id

			// Load Steam/Energy consumption
			getRawMaterialUnitOperationByStepId(stepId)
			// For Packaging/Distribution, use utilitiesId to load consumption data
			if (isPackagingOrDistribution && utilities.id) {
				getSteamConsumptionByUtilitiesId(utilities.id)
				getEnergyConsumptionByUtilitiesId(utilities.id)
			} else {
				getSteamConsumptionByStepId(stepId)
				getEnergyConsumptionByStepId(stepId)
			}
		} else {
			utilities = new Utilities()
			utilities.id = self.crypto.randomUUID()
			utilities.stepId = stepId
			// For Packaging/Distribution, set the generalInformationId on new utilities
			if (isPackagingOrDistribution && actualGeneralInformation.value) {
				utilities.generalInformationId = actualGeneralInformation.value
			}
			saveUtilities(false)
			notes.value = ""
			hvacRequiredValue.value = false
			selectedFacilityType.value = ""
			selectedCleanRoom.value = ""
			roomArea.value = 0
			duration.value = 0
			thisStepStatus.value = false

			getRawMaterialUnitOperationByStepId(stepId)
			// For Packaging/Distribution, always use defaults for new utilities to avoid loading data from other generalInformation
			if (isPackagingOrDistribution) {
				getDefaultSteamConsumption()
				getDefaultEnergyConsumption()
			} else {
				getSteamConsumptionByStepId(stepId)
				getEnergyConsumptionByStepId(stepId)
			}
		}
	})
}

function calculatioOfCFP(values: any, utilities: any): Promise<number | null> {
	return new Promise((resolve, reject) => {
		let processingOperationCF: ProcessingOperationCF = new ProcessingOperationCF()
		processingOperationCF.stepId = stepId.value
		if (utilities.id != null) {
			processingOperationCF.utilitiesId = utilities.id
		} else {
			processingOperationCF.utilitiesId = self.crypto.randomUUID()
		}
		processingOperationCF.rawMaterialUnitOperation = values

		processingOperationCF.steamConsumptionList = steamConsumptionList.value[0]
		processingOperationCF.energyConsumptionList = energyConsumptionList.value[0]
		if (processingOperationCF.rawMaterialUnitOperation.duration != null && processingOperationCF.rawMaterialUnitOperation.unitId != null) {
			apiClient.calculateProcessingOperationCF(processingOperationCF).then(
				(result) => {
					if (result != null) {
						resolve(result)
						//calculatedCF.value = result.toLocaleString("en-US", options)
					}
				},
				(err) => {
					resolve(null)
				}
			)
		}
	})
}

function getRawMaterialUnitOperationByStepId(stepId: string) {
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			apiClient
				.getRawMaterialUnitOperationByStepId(stepId, actualGeneralInformation.value)
				.then((result) => {
					if (result != null) {
						result.forEach((item) => {
							if (item.carbonFootprint != null) {
								item.carbonFootprint = item.carbonFootprint
							}
						})

						rawMaterialUnitOperation.value = result
						displayUnitOperation.value = true
						return result
					}
				})
				.then((result: any) => {
					rawMaterialUnitOperation.value.forEach((item: any) => {
						if (item.duration !== null && item.unitId !== null && item.carbonFootprint === null) {
							calculatioOfCFP(item, utilities).then((res) => {
								item.carbonFootprint = parseFloat(res)
							})
						}
					})
				})
				.then(() => {
					saveAllProcessingOperation(rawMaterialUnitOperation.value)
				})
			break
		case tabsDefinitions.biologics.value:
			apiClient.getunitOperationUtilitiesByStepId(stepId).then((result) => {
				if (result != null) {
					result.forEach((item) => {
						if (item.carbonFootprint != null) {
							item.carbonFootprint = item.carbonFootprint
						}
					})

					unitOperationStep.value = result
					unitOperationStep.value[0].duration = duration.value
					unitOperationStep.value[0].roomSize = roomArea.value
					if (hvacRequiredValue.value)
						processCleaningCalculation(stepId, props.tabId, props.assessmentId, result[0].unitOperationId, roomArea.value, duration.value)

					displayUnitOperation.value = true
				} else {
				}
			})
			break
		case tabsDefinitions.productProcess.value:
			apiClient.getunitOperationUtilitiesByStepId(stepId).then((result) => {
				if (result != null) {
					result.forEach((item) => {
						if (item.carbonFootprint != null) {
							item.carbonFootprint = item.carbonFootprint
						}
					})

					unitOperationStep.value = result
					unitOperationStep.value[0].duration = duration.value

					unitOperationStep.value[0].roomSize = roomArea.value
					if (hvacRequiredValue.value)
						processCleaningCalculation(stepId, props.tabId, props.assessmentId, result[0].unitOperationId, roomArea.value, duration.value)

					displayUnitOperation.value = true
				} else {
				}
			})
			break
	}
}

function processCleaningCalculation(
	stepId: string,
	tabId: string,
	assessmentId: string,
	unitOperationId: string,
	roomArea: number,
	duration: number
) {
	if (roomArea !== null && duration !== null)
		apiClient.getProcessingCleaningCalculation(stepId, tabId, assessmentId, unitOperationId, roomArea, duration).then((res) => {
			unitOperationStep.value[0].carbonFootprint = res
		})
}

async function getDefaultSteamConsumption() {
	dataLoading.value = true
	apiClient.getSteamConsumptionDefault().then(
		async (result) => {
			if (result != null) {
				steamConsumptionDefaultList.value = result
				if (steamConsumptionDefaultList.value != null) {
					naturalGasValue.value = steamConsumptionDefaultList.value[0].natualGas
					coalValue.value = steamConsumptionDefaultList.value[0].coal
					dieselValue.value = steamConsumptionDefaultList.value[0].diesel
					biomassValue.value = steamConsumptionDefaultList.value[0].biomass

					utilitiesSteamConsumptionObj.id = self.crypto.randomUUID()
					utilitiesSteamConsumptionObj.stepId = stepId.value
					if (utilities.id != null) {
						utilitiesSteamConsumptionObj.utilitiesId = utilities.id
					}
					utilitiesSteamConsumptionObj.naturalGas = naturalGasValue.value
					utilitiesSteamConsumptionObj.coal = coalValue.value
					utilitiesSteamConsumptionObj.diesel = dieselValue.value
					utilitiesSteamConsumptionObj.biomass = biomassValue.value

					steamConsumptionList.value = []
					steamConsumptionList.value.push(utilitiesSteamConsumptionObj)
					displaySteamConsumptionList.value = true
					calculateTotalSteamConsumption()
					await nextTick()
				}
			}
			dataLoading.value = false
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
			dataLoading.value = false
		}
	)
}

function setConsumptionDefaults(type: string) {
	switch (type) {
		case "steam":
			apiClient.getSteamConsumptionDefault().then((result) => {
				naturalGasValue.value = result[0].natualGas ? result[0].natualGas : 0
				coalValue.value = result[0].coal ? result[0].coal : 0
				dieselValue.value = result[0].diesel ? result[0].diesel : 0
				biomassValue.value = result[0].biomass ? result[0].biomass : 0
				calculateTotalSteamConsumption()
				toast.add({
					severity: "success",
					summary: "Default Values Applied",
					detail: "Steam Consumption default values have been applied successfully.",
					life: 3000,
				})
			})
			break
		case "energy":
			apiClient.getEnergyConsumptionDefault().then((result) => {
				gridAverageMixValue.value = result[0].gridAverageMix ? result[0].gridAverageMix : 0
				gridGreenTariffValue.value = result[0].gridGreenTariff ? result[0].gridGreenTariff : 0
				solarValue.value = result[0].solar ? result[0].solar : 0
				windValue.value = result[0].wind ? result[0].wind : 0
				onSiteHydroValue.value = result[0].onSiteHydro ? result[0].onSiteHydro : 0
				onSiteBiomassValue.value = result[0].onSiteBiomass ? result[0].onSiteBiomass : 0
				calculateTotalEnergyConsumption()
				toast.add({
					severity: "success",
					summary: "Default Values Applied",
					detail: "Electricity Consumption default values have been applied successfully.",
					life: 3000,
				})
			})
	}
}

async function getDefaultEnergyConsumption() {
	apiClient.getEnergyConsumptionDefault().then(async (result) => {
		if (result != null) {
			energyConsumptionDefaultList.value = result
			if (energyConsumptionDefaultList.value != null) {
				gridAverageMixValue.value = energyConsumptionDefaultList.value[0].gridAverageMix ? energyConsumptionDefaultList.value[0].gridAverageMix : 0
				gridGreenTariffValue.value = energyConsumptionDefaultList.value[0].gridGreenTariff ? energyConsumptionDefaultList.value[0].gridGreenTariff : 0
				solarValue.value = energyConsumptionDefaultList.value[0].solar ? energyConsumptionDefaultList.value[0].solar : 0
				windValue.value = energyConsumptionDefaultList.value[0].wind ? energyConsumptionDefaultList.value[0].wind : 0
				onSiteHydroValue.value = energyConsumptionDefaultList.value[0].onSiteHydro ? energyConsumptionDefaultList.value[0].onSiteHydro : 0
				onSiteBiomassValue.value = energyConsumptionDefaultList.value[0].onSiteBiomass ? energyConsumptionDefaultList.value[0].onSiteBiomass : 0

				utilitiesEnergyConsumptionObj.id = self.crypto.randomUUID()
				utilitiesEnergyConsumptionObj.stepId = stepId.value
				if (utilities != null) {
					utilitiesEnergyConsumptionObj.utilitiesId = utilities.id
				}
				utilitiesEnergyConsumptionObj.gridAverageMix = gridAverageMixValue.value
				utilitiesEnergyConsumptionObj.gridGreenTariff = gridGreenTariffValue.value
				utilitiesEnergyConsumptionObj.solar = solarValue.value
				utilitiesEnergyConsumptionObj.wind = windValue.value
				utilitiesEnergyConsumptionObj.onSiteHydro = onSiteHydroValue.value
				utilitiesEnergyConsumptionObj.onSiteBiomass = onSiteBiomassValue.value

				energyConsumptionList.value = []
				energyConsumptionList.value.push(utilitiesEnergyConsumptionObj)
				displayEnergyConsumptionList.value = true
				calculateTotalEnergyConsumption()
				await nextTick()
			}
		}
	})
}

async function getSteamConsumptionByStepId(stepId: string) {
	dataLoading.value = true
	apiClient.getSteamConsumptionByStepId(stepId).then(
		async (result) => {
			if (result != null && result.length > 0) {
				steamConsumptionList.value = result
				naturalGasValue.value = steamConsumptionList.value[0].naturalGas ? steamConsumptionList.value[0].naturalGas : 0
				coalValue.value = steamConsumptionList.value[0].coal ? steamConsumptionList.value[0].coal : 0
				dieselValue.value = steamConsumptionList.value[0].diesel ? steamConsumptionList.value[0].diesel : 0
				biomassValue.value = steamConsumptionList.value[0].biomass ? steamConsumptionList.value[0].biomass : 0

				utilitiesSteamConsumptionObj.id = steamConsumptionList.value[0].id
				utilitiesSteamConsumptionObj.stepId = steamConsumptionList.value[0].stepId
				utilitiesSteamConsumptionObj.utilitiesId = steamConsumptionList.value[0].utilitiesId

				displaySteamConsumptionList.value = true
				calculateTotalSteamConsumption()
				await nextTick()
			} else {
				getDefaultSteamConsumption()
			}

			dataLoading.value = false
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
			dataLoading.value = false
		}
	)
}

function getDataFromRawMaterialScreen() {
	//var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
	var toGetStatus = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId)
	var selectedStepName = toGetStatus.actualSubTabName
	stepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
	actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
		(item: any) => item.actualMainTabId === props.tabId
	).generalInformationId
	if (actualGeneralInformation === undefined || stepId.value === undefined || props.tabId === undefined) return
	switch (props.tabName) {
		case tabsDefinitions.syntheticAPI.value:
			apiClient
				.getRawMaterialsByGeneraInformationIdScreenIdStepId(actualGeneralInformation.value, props.tabId, stepId.value, selectedStepName)
				.then((res) => {
					if (res !== null) {
						notes.value = res.note
						BDSMassOutput.value = res.massOfProduct + " " + res.unit.unitName
						BDSConcentration.value = res.bdsConcentration + " " + res.bdsUnit.unitName
						siteLocation.value = res.siteLocation.siteLocationName
						unitOperation.value = res.rawMaterialUnitOperation
							?.filter((item) => item.isActive == true)
							.map((item) => item.unitOperation.unitOperationName)
							.join(", ")
					} else {
					}
				})
			break
		case tabsDefinitions.biologics.value:
			apiClient.getBasicDataByGeneraInformationIdScreenId(actualGeneralInformation.value, props.tabId, stepId.value).then(
				(res) => {
					if (res !== null) {
						//notes.value = res.notes
						BDSMassOutput.value = res.proteinMassOutput + " " + res.proteinMOUnit.unitName
						BDSConcentration.value = res.concProteinMassProdOutput + " " + res.concentrationUnit.unitName
						siteLocation.value = res.siteLocation.siteLocationName
					}
				},
				(err) => {
					toast.add({ severity: "error", summary: `Error: ${err}` })
				}
			)
			break
		case tabsDefinitions.productProcess.value:
			apiClient.getBasicDataByGeneraInformationIdScreenId(actualGeneralInformation.value, props.tabId, stepId.value).then((res) => {
				if (res !== null) {
					//notes.value = res.notes
					// BDSMassOutput.value = res.proteinMassOutput + " " + res.proteinMOUnit.unitName
					// BDSConcentration.value = res.concProteinMassProdOutput + " " + res.concentrationUnit.unitName
					//siteLocation.value = res.siteLocation.siteLocationName
				} else {
				}
			})
			break
	}
}

async function getEnergyConsumptionByStepId(stepId: string) {
	apiClient.getEnergyConsumptionByStepId(stepId).then(async (result) => {
		if (result != null && result.length > 0) {
			energyConsumptionList.value = result
			gridAverageMixValue.value = energyConsumptionList.value[0].gridAverageMix ? energyConsumptionList.value[0].gridAverageMix : 0
			gridGreenTariffValue.value = energyConsumptionList.value[0].gridGreenTariff ? energyConsumptionList.value[0].gridGreenTariff : 0
			solarValue.value = energyConsumptionList.value[0].solar ? energyConsumptionList.value[0].solar : 0
			windValue.value = energyConsumptionList.value[0].wind ? energyConsumptionList.value[0].wind : 0
			onSiteHydroValue.value = energyConsumptionList.value[0].onSiteHydro ? energyConsumptionList.value[0].onSiteHydro : 0
			onSiteBiomassValue.value = energyConsumptionList.value[0].onSiteBiomass ? energyConsumptionList.value[0].onSiteBiomass : 0

			utilitiesEnergyConsumptionObj.id = energyConsumptionList.value[0].id
			utilitiesEnergyConsumptionObj.stepId = energyConsumptionList.value[0].stepId
			utilitiesEnergyConsumptionObj.utilitiesId = energyConsumptionList.value[0].utilitiesId

			displayEnergyConsumptionList.value = true
			calculateTotalEnergyConsumption()
			await nextTick()
		} else {
			getDefaultEnergyConsumption()
		}
		if (props.tabName === tabsDefinitions.biologics.value || props.tabName === tabsDefinitions.productProcess.value) getDataFromRawMaterialScreen()
	})
}

// Get Steam Consumption by utilitiesId - Used only for Packaging and Distribution tabs
async function getSteamConsumptionByUtilitiesId(utilitiesId: string) {
	dataLoading.value = true
	apiClient.getSteamConsumptionByUtilitiesId(utilitiesId).then(
		async (result) => {
			if (result != null && result.length > 0) {
				steamConsumptionList.value = result
				naturalGasValue.value = steamConsumptionList.value[0].naturalGas ? steamConsumptionList.value[0].naturalGas : 0
				coalValue.value = steamConsumptionList.value[0].coal ? steamConsumptionList.value[0].coal : 0
				dieselValue.value = steamConsumptionList.value[0].diesel ? steamConsumptionList.value[0].diesel : 0
				biomassValue.value = steamConsumptionList.value[0].biomass ? steamConsumptionList.value[0].biomass : 0

				utilitiesSteamConsumptionObj.id = steamConsumptionList.value[0].id
				utilitiesSteamConsumptionObj.stepId = steamConsumptionList.value[0].stepId
				utilitiesSteamConsumptionObj.utilitiesId = steamConsumptionList.value[0].utilitiesId

				displaySteamConsumptionList.value = true
				calculateTotalSteamConsumption()
				await nextTick()
			} else {
				getDefaultSteamConsumption()
			}

			dataLoading.value = false
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}` })
			dataLoading.value = false
		}
	)
}

// Get Energy Consumption by utilitiesId - Used only for Packaging and Distribution tabs
async function getEnergyConsumptionByUtilitiesId(utilitiesId: string) {
	apiClient.getEnergyConsumptionByUtilitiesId(utilitiesId).then(async (result) => {
		if (result != null && result.length > 0) {
			energyConsumptionList.value = result
			gridAverageMixValue.value = energyConsumptionList.value[0].gridAverageMix ? energyConsumptionList.value[0].gridAverageMix : 0
			gridGreenTariffValue.value = energyConsumptionList.value[0].gridGreenTariff ? energyConsumptionList.value[0].gridGreenTariff : 0
			solarValue.value = energyConsumptionList.value[0].solar ? energyConsumptionList.value[0].solar : 0
			windValue.value = energyConsumptionList.value[0].wind ? energyConsumptionList.value[0].wind : 0
			onSiteHydroValue.value = energyConsumptionList.value[0].onSiteHydro ? energyConsumptionList.value[0].onSiteHydro : 0
			onSiteBiomassValue.value = energyConsumptionList.value[0].onSiteBiomass ? energyConsumptionList.value[0].onSiteBiomass : 0

			utilitiesEnergyConsumptionObj.id = energyConsumptionList.value[0].id
			utilitiesEnergyConsumptionObj.stepId = energyConsumptionList.value[0].stepId
			utilitiesEnergyConsumptionObj.utilitiesId = energyConsumptionList.value[0].utilitiesId

			displayEnergyConsumptionList.value = true
			calculateTotalEnergyConsumption()
			await nextTick()
		} else {
			getDefaultEnergyConsumption()
		}
	})
}

function getAllFacilityType() {
	apiClient.getFacilityType().then((res: any) => {
		facilityTypeList.value = res
	})
}

function getAllUnit() {
	apiClient.getUnitByUnitTypeName("Duration").then((res: any) => {
		unitList.value = res
	})
}

function editProcessingOperation(row: RawMaterialUnitOperation) {
	editProcessingOperationRow.value = true
	selectedProcessingOperationId.value = row.id
	selectedUnitId.value = row.unitId
	calculatedCF.value = row.carbonFootprint
	//row.selectedUnitId = row.unitId
	row.editable = true
}

function saveProcessingOperation(row: RawMaterialUnitOperation) {
	if (!testFields(row)) return
	editProcessingOperationRow.value = false
	apiClient.updateRawMaterialUnitOperation(row).then(
		(res) => {
			displayUnitOperation.value = false
			selectedProcessingOperationId.value = ""
			getRawMaterialUnitOperationByStepId(stepId.value)
			toast.add({ severity: "success", summary: "Saved!", detail: "", life: 3500 })
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}`, life: 2000 })
		}
	)
}

function saveAllProcessingOperation(rows: RawMaterialUnitOperation[]) {
	editProcessingOperationRow.value = false
	apiClient.updateAllRawMaterialUnitOperation(rows).then(
		(res) => {
			displayUnitOperation.value = false
			selectedProcessingOperationId.value = ""
		},
		(err) => {
			toast.add({ severity: "error", summary: `Error: ${err}`, life: 2000 })
		}
	)
}

function cancelProcessingOperation(row: RawMaterialUnitOperation) {
	editProcessingOperationRow.value = false
	displayUnitOperation.value = false
	selectedProcessingOperationId.value = ""
	getRawMaterialUnitOperationByStepId(stepId.value)
}

function deleteProcessingOperation(row: RawMaterialUnitOperation) {}

function durationChange(row: RawMaterialUnitOperation) {
	calculateProcessingOperationCF(row)
}

function unitChange(row: RawMaterialUnitOperation) {
	if (selectedUnitId.value != null) {
		row.unitId = selectedUnitId.value
		calculateProcessingOperationCF(row)
	}
}

function calculateProcessingOperationCF(row: RawMaterialUnitOperation) {
	let processingOperationCF: ProcessingOperationCF = new ProcessingOperationCF()
	processingOperationCF.stepId = stepId.value
	processingOperationCF.utilitiesId = utilities.id
	processingOperationCF.rawMaterialUnitOperation = row
	processingOperationCF.steamConsumptionList = steamConsumptionList.value[0]
	processingOperationCF.energyConsumptionList = energyConsumptionList.value[0]

	apiClient.calculateProcessingOperationCF(processingOperationCF).then((result) => {
		if (result != null) {
			row.carbonFootprint = result
			calculatedCF.value = result
		}
	})
}

function testFields(row: RawMaterialUnitOperation) {
	if (row.duration == null && selectedUnitId.value == null) {
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "You must complete the highlighted fields",
		})
		saveAttempted.value = true
		return false
	}

	return true
}

function testUtilitiesSteamConsumption(utilitiesSteamConsumptionObj: UtilitiesSteamConsumption) {
	if (
		utilitiesSteamConsumptionObj.naturalGas == null &&
		utilitiesSteamConsumptionObj.coal == null &&
		utilitiesSteamConsumptionObj.diesel == null &&
		utilitiesSteamConsumptionObj.biomass == null
	) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "You must complete the highlighted fields",
		// 	life: 5000,
		// })
		saveUtilitiesData.value = true
		return false
	} else if (totalSteamConsumption.value != 100 && steamConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Steam Consumption total should be 100",
		// 	life: 5000,
		// })
		steamConsumptionErrorFlagged.value = true
		setTimeout(() => {
			steamConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	}

	return true
}

function testUtilitiesEnergyConsumption(utilitiesEnergyConsumptionObj: UtilitiesEnergyConsumption) {
	if (
		utilitiesEnergyConsumptionObj.gridAverageMix == null &&
		utilitiesEnergyConsumptionObj.gridGreenTariff == null &&
		utilitiesEnergyConsumptionObj.solar == null &&
		utilitiesEnergyConsumptionObj.wind == null &&
		utilitiesEnergyConsumptionObj.onSiteHydro == null &&
		utilitiesEnergyConsumptionObj.onSiteBiomass == null
	) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "You must complete the highlighted fields",
		// 	life: 5000,
		// })
		saveUtilitiesData.value = true
		return false
	} else if (totalEnergyConsumption.value != 100 && energyConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Energy Consumption total should be 100",
		// 	life: 5000,
		// })
		energyConsumptionErrorFlagged.value = true
		setTimeout(() => {
			energyConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	}

	return true
}

function testUtilitiesConsumption() {
	if (totalSteamConsumption.value != 100 && steamConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Steam Consumption total should be 100",
		// 	life: 5000,
		// })
		steamConsumptionErrorFlagged.value = true
		setTimeout(() => {
			steamConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	} else if (totalEnergyConsumption.value != 100 && energyConsumptionErrorFlagged.value == false) {
		// toast.add({
		// 	severity: "error",
		// 	summary: "Error",
		// 	detail: "Energy Consumption total should be 100",
		// 	life: 5000,
		// })
		energyConsumptionErrorFlagged.value = true
		setTimeout(() => {
			energyConsumptionErrorFlagged.value = false
		}, 5000)
		saveUtilitiesData.value = true
		return false
	}

	if (totalSteamConsumption.value != 100 || totalEnergyConsumption.value != 100) {
		return false
	}

	return true
}

function checkIfEmpty(tableName: string, fieldName: string) {
	if (tableName == "energyConsumption") {
		switch (fieldName) {
			case "solar":
				if (solarValue.value == "") {
					solarValue.value = 0
				}
				break
			case "wind":
				if (windValue.value == "") {
					windValue.value = 0
				}
				break
			case "onSiteHydro":
				if (onSiteHydroValue.value == "") {
					onSiteHydroValue.value = 0
				}
				break
			case "onSiteBiomass":
				if (onSiteBiomassValue.value == "") {
					onSiteBiomassValue.value = 0
				}
				break
			case "gridGreenTariff":
				if (gridGreenTariffValue.value == "") {
					gridGreenTariffValue.value = 0
				}
				break
			case "gridAverageMix":
				if (gridAverageMixValue.value == "") {
					gridAverageMixValue.value = 0
				}
				break
		}
	}
	if (tableName == "steamConsumption") {
		switch (fieldName) {
			case "biomass":
				if (biomassValue.value == "") {
					biomassValue.value = 0
				}
				break
			case "diesel":
				if (dieselValue.value == "") {
					dieselValue.value = 0
				}
				break
			case "coal":
				if (coalValue.value == "") {
					coalValue.value = 0
				}
				break
			case "natualGas":
				if (naturalGasValue.value == "") {
					naturalGasValue.value = 0
				}
				break
		}
	}
}

function numbersOnly(evt) {
	evt = evt ? evt : window.event
	var charCode = evt.which ? evt.which : evt.keyCode
	//if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
	if (
		(charCode != 46 || evt.target.value.indexOf(".") != -1) && // “.” CHECK DOT, AND ONLY ONE.
		(charCode < 48 || charCode > 57)
	) {
		evt.preventDefault()
		return false
	} else {
		return true
	}
}

const selectedCleanRoomDisable = ref(true)

function facilityTypeChange(facilityTypeId: string) {
	var actualFacility = facilityTypeList.value.find((item) => item.id === facilityTypeId)
	if (actualFacility?.isoClassFacilityTypeName === "Conventional HVAC (No Clean Room)") {
		selectedCleanRoomDisable.value = true
	} else {
		apiClient.getCleanRoomClass(facilityTypeId).then((res: any) => {
			cleanRoomList.value = res
			selectedCleanRoomDisable.value = false
		})
	}
}

function checkIfTotalIs100(total: number) {
	if (total > 100 || total < 100) return "red"
	else "black"
}

function calculateTotalSteamConsumption() {
	let sum =
		parseFloat(naturalGasValue.value.toString()) +
		parseFloat(coalValue.value.toString()) +
		parseFloat(dieselValue.value.toString()) +
		parseFloat(biomassValue.value.toString())

	// if (sum != 100 && steamConsumptionErrorFlagged.value == false) {
	// 	toast.add({
	// 		severity: "error",
	// 		summary: "Error",
	// 		detail: "Steam Consumption total should be 100",
	// 		life: 5000,
	// 	})
	// 	steamConsumptionErrorFlagged.value = true
	// 	setTimeout(() => {
	// 		steamConsumptionErrorFlagged.value = false
	// 	}, 5000)
	// }

	totalSteamConsumption.value = sum
	//saveUtilitiesSteamConsumption()
}

function calculateTotalEnergyConsumption() {
	let sum =
		parseFloat(gridAverageMixValue.value ? gridAverageMixValue.value.toString() : "0") +
		parseFloat(gridGreenTariffValue.value ? gridGreenTariffValue.value.toString() : "0") +
		parseFloat(solarValue.value ? solarValue.value.toString() : "0") +
		parseFloat(windValue.value ? windValue.value.toString() : "0") +
		parseFloat(onSiteHydroValue.value ? onSiteHydroValue.value.toString() : "0") +
		parseFloat(onSiteBiomassValue.value ? onSiteBiomassValue.value.toString() : "0")

	// if (sum != 100 && energyConsumptionErrorFlagged.value == false) {
	// 	toast.add({
	// 		severity: "error",
	// 		summary: "Error",
	// 		detail: "Energy Consumption total should be 100",
	// 		life: 5000,
	// 	})
	// 	energyConsumptionErrorFlagged.value = true
	// 	setTimeout(() => {
	// 		energyConsumptionErrorFlagged.value = false
	// 	}, 5000)
	// }

	//function saveUtilitiesSteamConsumption()
	totalEnergyConsumption.value = sum
	// Don't auto-save on calculation - only save when user clicks Save button
	// saveUtilitiesEnergyConsumption()
}

// Energy Multipliers Functions
async function checkIfAllowedScreen(): Promise<boolean> {
	const allowedScreens = ["Synthetic API", "Biologics", "Product Process", "Device & Packaging"]

	var projectClient = new ProjectClient(import.meta.env.VITE_API_URL?.toString())
	await projectClient.isProjectMultiStepUtilities(props.assessmentId).then(
		(result) => {
			multiStepUtilitiesEnabled.value = result
		},
		(err) => {
			useErrorToaster(err)
		}
	)

	return allowedScreens.includes(props.tabName) && !multiStepUtilitiesEnabled.value
}

async function initializeEnergyMultipliers() {
	// Check if we have the minimum required data
	if (!props.assessmentId || !props.tabId || !actualGeneralInformation.value) {
		return
	}

	showEnergyMultipliers.value = await checkIfAllowedScreen()
	if (showEnergyMultipliers.value) {
		await loadEnergyMultipliers()
	}
}

async function loadEnergyMultipliers() {
	try {
		energyMultipliersLoading.value = true

		// Determine the product format source screen ID
		// For "Synthetic API" and "Biologics" screens, use tabId for both parameters
		let productFormatSourceScreenId = props.tabId
		if (props.tabId !== "Synthetic API" && props.tabId !== "Biologics") {
			// For other screens, get from the API
			const generalInformationClient = new GeneralInformationClient(import.meta.env.VITE_API_URL?.toString())
			const apiResult = await generalInformationClient.getProductFormatSourceScreenId(props.assessmentId, props.tabId)
			// If API returns undefined, fallback to tabId
			productFormatSourceScreenId = apiResult || props.tabId
		}

		// First try to get assessment-specific multipliers using the new filtered API
		let response = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			props.assessmentId // assessmentId for assessment-specific data
		)

		if (response && response.length > 0) {
			energyMultipliers.value = response
			energyMultipliersType.value = "assessment"
			originalEnergyMultipliers.value = JSON.parse(JSON.stringify(response))
			return
		}

		// Fall back to global defaults using the new filtered API
		response = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			undefined // assessmentId = undefined for global defaults
		)

		energyMultipliers.value = response || []
		energyMultipliersType.value = "global"
		originalEnergyMultipliers.value = JSON.parse(JSON.stringify(response || []))
	} catch (error) {
		console.error("❌ Error loading energy multipliers:", error)
		toast.add({
			severity: "error",
			summary: "Error loading energy multipliers",
			detail: "Please try again",
		})
	} finally {
		energyMultipliersLoading.value = false
	}
}

// Handle switch change for energy multipliers type
function onSwitchChange(value: boolean) {
	energyMultipliersType.value = value ? "assessment" : "global"
	onEnergyMultipliersTypeChange()
}

async function onEnergyMultipliersTypeChange() {
	try {
		if (energyMultipliersType.value === "global") {
			// Switching to Global Default - ask for confirmation and delete assessment-specific data
			confirmDialog.require({
				message: "Switching to Global Default will remove assessment-specific data. Are you sure?",
				header: "Confirm Change",
				icon: "pi pi-exclamation-triangle",
				acceptLabel: "Yes, Switch",
				rejectLabel: "Cancel",
				acceptClass: "p-button-danger",
				accept: async () => {
					await deleteAssessmentSpecificMultipliers()
					await loadEnergyMultipliers()
				},
				reject: () => {
					energyMultipliersType.value = "assessment"
				},
			})
		} else {
			// Switching to Assessment Specific - copy global defaults and save to database
			await copyGlobalDefaultsToAssessment()
			await loadEnergyMultipliers()
		}
	} catch (error) {
		console.error("Error changing energy multipliers type:", error)
		toast.add({
			severity: "error",
			summary: "Error",
			detail: "Failed to change multiplier type. Please try again.",
		})
	}
}

// Copy global default multipliers to assessment-specific
async function copyGlobalDefaultsToAssessment() {
	try {
		// Determine the product format source screen ID
		// For "Synthetic API" and "Biologics" screens, use tabId for both parameters
		let productFormatSourceScreenId = props.tabId
		if (props.tabId !== "Synthetic API" && props.tabId !== "Biologics") {
			// For other screens, get from the API
			const generalInformationClient = new GeneralInformationClient(import.meta.env.VITE_API_URL?.toString())
			const apiResult = await generalInformationClient.getProductFormatSourceScreenId(props.assessmentId, props.tabId)
			// If API returns undefined, fallback to tabId
			productFormatSourceScreenId = apiResult || props.tabId
		}

		// Get global defaults from database using the same logic as loadEnergyMultipliers
		const globalDefaults = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			undefined // assessmentId = undefined for global defaults
		)

		if (!globalDefaults || globalDefaults.length === 0) {
			return
		}

		// Create assessment-specific copies
		const assessmentSpecificMultipliers = globalDefaults.map((multiplier) => {
			return new EnergyMultipliers({
				id: getEmptyGuid(), // Force creation with empty GUID
				assessmentId: props.assessmentId, // Link to current assessment
				energyId: multiplier.energyId,
				moduleScreenId: multiplier.moduleScreenId,
				productFormatSourceScreenId: multiplier.productFormatSourceScreenId,
				value: multiplier.value,
				isActive: true,
			})
		})

		// Save to database and get the response with real IDs
		const savedMultipliers = await energyMultipliersClient.save(assessmentSpecificMultipliers)

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Global defaults copied to assessment-specific values.",
			life: 3000,
		})
	} catch (error) {
		console.error("❌ Error copying global defaults:", error)
		throw error
	}
}

// Delete all assessment-specific multipliers for this assessment
async function deleteAssessmentSpecificMultipliers() {
	try {
		// Determine the product format source screen ID
		// For "Synthetic API" and "Biologics" screens, use tabId for both parameters
		let productFormatSourceScreenId = props.tabId
		if (props.tabId !== "Synthetic API" && props.tabId !== "Biologics") {
			// For other screens, get from the API
			const generalInformationClient = new GeneralInformationClient(import.meta.env.VITE_API_URL?.toString())
			const apiResult = await generalInformationClient.getProductFormatSourceScreenId(props.assessmentId, props.tabId)
			// If API returns undefined, fallback to tabId
			productFormatSourceScreenId = apiResult || props.tabId
		}

		// Get all assessment-specific multipliers for this assessment and moduleScreen
		const assessmentMultipliers = await energyMultipliersClient.listFiltered(
			props.tabId, // moduleScreenId
			productFormatSourceScreenId, // productFormatSourceScreenId
			props.assessmentId // assessmentId for assessment-specific data
		)

		if (!assessmentMultipliers || assessmentMultipliers.length === 0) {
			return
		}

		// Delete each multiplier
		for (const multiplier of assessmentMultipliers) {
			if (multiplier.id) {
				await energyMultipliersClient.delete(multiplier.id)
			}
		}

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Assessment-specific values removed. Showing global defaults.",
			life: 3000,
		})
	} catch (error) {
		console.error("❌ Error deleting assessment-specific multipliers:", error)
		throw error
	}
}

function enterEnergyMultipliersEditMode() {
	energyMultipliersEditMode.value = true
	energyMultipliersSaveAttempted.value = false
	originalEnergyMultipliers.value = JSON.parse(JSON.stringify(energyMultipliers.value))
}

function hasEnergyMultipliersUnsavedChanges(): boolean {
	const currentJson = JSON.stringify(energyMultipliers.value)
	const originalJson = JSON.stringify(originalEnergyMultipliers.value)
	return currentJson !== originalJson
}

function cancelEnergyMultipliersEdit() {
	if (hasEnergyMultipliersUnsavedChanges()) {
		confirmDialog.require({
			message: "Are you sure you want to cancel? Any unsaved changes will be lost.",
			header: "Cancel Changes",
			icon: "pi pi-exclamation-triangle",
			acceptLabel: "Yes, Cancel",
			rejectLabel: "Continue Editing",
			acceptClass: "p-button-danger",
			accept: () => {
				performEnergyMultipliersCancel()
			},
		})
	} else {
		performEnergyMultipliersCancel()
	}
}

function performEnergyMultipliersCancel() {
	energyMultipliers.value = JSON.parse(JSON.stringify(originalEnergyMultipliers.value))
	energyMultipliersEditMode.value = false
	energyMultipliersSaveAttempted.value = false
}

function isEnergyMultiplierFieldInvalid(data: EnergyMultipliers, fieldName: keyof EnergyMultipliers) {
	if (!energyMultipliersSaveAttempted.value) return false

	const fieldValue = data[fieldName]

	if (fieldName === "value") {
		return fieldValue === null || fieldValue === undefined
	}

	return !fieldValue || fieldValue === ""
}

function validateEnergyMultipliers(): boolean {
	let isValid = true

	for (const multiplier of energyMultipliers.value) {
		if (multiplier.value === null || multiplier.value === undefined) {
			isValid = false
			break
		}
	}

	if (!isValid) {
		toast.add({
			severity: "error",
			summary: "Missing Required Fields",
			detail: "Please fill in all required fields for each energy multiplier.",
		})
	}

	return isValid
}

async function saveEnergyMultipliers() {
	energyMultipliersSaveAttempted.value = true

	if (!validateEnergyMultipliers()) {
		return
	}

	try {
		energyMultipliersLoading.value = true

		// Prepare multipliers for API - use proper EnergyMultipliers class
		const multipliersToSave = energyMultipliers.value.map((multiplier) => {
			// Check if this record already exists (has a valid ID) or needs to be created
			const hasValidId = multiplier.id && multiplier.id !== getEmptyGuid()
			const finalId = hasValidId ? multiplier.id : getEmptyGuid()

			const em = new EnergyMultipliers({
				id: finalId,
				assessmentId: energyMultipliersType.value === "assessment" ? props.assessmentId : undefined,
				energyId: multiplier.energyId,
				moduleScreenId: multiplier.moduleScreenId,
				productFormatSourceScreenId: multiplier.productFormatSourceScreenId || undefined,
				value: multiplier.value,
				isActive: multiplier.isActive ?? true,
			})

			const rawValue = multiplier.energyId ? energyMultiplierRawValues.get(multiplier.energyId) : null
			const valueStr = rawValue ?? (typeof multiplier.value === "string" ? multiplier.value as string : null)
			if (valueStr) {
				patchEntityForPrecision(em, { value: valueStr })
			}

			return em
		})

		const response = await energyMultipliersClient.save(multipliersToSave)

		toast.add({
			severity: "success",
			summary: "Success",
			detail: "Energy multipliers saved successfully.",
			life: 3000,
		})

		// Reload data to get updated information
		await loadEnergyMultipliers()

		// Exit edit mode
		energyMultipliersEditMode.value = false
		energyMultipliersSaveAttempted.value = false
	} catch (error) {
		console.error("Error saving energy multipliers:", error)
		const errorMessage = error instanceof Error ? error.message : "Please try again"
		toast.add({
			severity: "error",
			summary: "Error saving energy multipliers",
			detail: errorMessage,
		})
	} finally {
		energyMultipliersLoading.value = false
	}
}
</script>

<style lang="scss" scoped>
.p-invalid {
	border-color: red !important;
}
.invalid-table {
	border: 1px solid red !important;
	border-radius: 2px !important;
}
.stepName {
	font-weight: bold;
	font-size: 20;
	color: rgb(0, 51, 98);
}
.btn-outline {
	background-color: white;
	color: var(--primary);
	border: 2px solid var(--primary);
	padding: 5px 10px;
	font-size: 12px;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.btn-outline:hover {
	background-color: #007bff;
	color: white;
}
</style>
